import { atom } from 'jotai';

export const navigationIsOpen = atom<boolean>(false);
